/*
 * Mobile sticky add-to-cart bar.
 *
 * Shows `[data-mobile-sticky]` (a fixed bar at the bottom of the viewport, mobile
 * only — visibility is gated by CSS at <=749px) once the inline buy-buttons
 * `[data-inline-buy-buttons]` have scrolled ABOVE the viewport (i.e. the user has
 * scrolled past them), and hides it again when they come back into/below view.
 *
 * We intentionally key off "scrolled past" rather than "not intersecting":
 * "not intersecting" is also true while the inline buttons are still BELOW the
 * fold (not reached yet) and when scrolling further down the page, which would
 * make the bar flicker visible/invisible/visible. The bar is also hidden once
 * the footer (`.footer`) enters the viewport so it doesn't overlap it. The
 * bar is a real second <product-form>, so nothing is proxied here — this only
 * toggles `.is-visible`.
 */
(function () {
  function initStickyBar(sticky) {
    // Pair the bar with the inline buy-buttons from the same product-info section.
    const productInfo = sticky.closest('product-info') || document;
    const inlineButtons = productInfo.querySelector('[data-inline-buy-buttons]');
    const footer = document.querySelector('.footer');

    // No inline buttons (e.g. buy_buttons block removed): keep the bar permanently
    // visible so the only add-to-cart on mobile stays reachable.
    if (!inlineButtons || !('IntersectionObserver' in window)) {
      sticky.classList.add('is-visible');
      return;
    }

    // Combined state: show only when scrolled past the inline buttons AND the
    // footer is not yet on screen. Both observers update their own flag and then
    // re-evaluate the result together.
    let scrolledPastButtons = false;
    let footerVisible = false;

    const apply = () => {
      sticky.classList.toggle('is-visible', scrolledPastButtons && !footerVisible);
    };

    const buttonsObserver = new IntersectionObserver(
      ([entry]) => {
        // Scrolled past = inline buttons fully above the viewport top.
        scrolledPastButtons = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
        apply();
      },
      { rootMargin: '0px', threshold: 0 }
    );
    buttonsObserver.observe(inlineButtons);

    if (footer) {
      const footerObserver = new IntersectionObserver(
        ([entry]) => {
          footerVisible = entry.isIntersecting;
          apply();
        },
        { rootMargin: '0px', threshold: 0 }
      );
      footerObserver.observe(footer);
    }
  }

  function init(root) {
    (root || document).querySelectorAll('[data-mobile-sticky]').forEach(initStickyBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
})();
